import { createFileRoute } from '@tanstack/react-router'

import PageReferencePlayground from '@/pages/PageReferencePlayground'

export const Route = createFileRoute('/reference-playground')({ component: PageReferencePlayground })
